// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import brandAuroraLogo from '../static/brand_aurora_logo.svg';
import deadEndImage from '../static/dead_end_404.webp';
export function NotFoundPage() {
    return /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            alignItems: 'center',
            minHeight: '100vh',
            bgcolor: 'common.white',
            px: 5,
            pt: 10,
            maxWidth: 480,
            mx: 'auto'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: brandAuroraLogo,
        alt: "Aurora",
        sx: {
            height: 20
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: deadEndImage,
        alt: "Dead end road sign illustration",
        sx: {
            mt: 10,
            width: 234,
            height: 'auto'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        color: "text.primary",
        align: "center",
        sx: {
            mt: 8
        }
    }, "404 error"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "text.secondary",
        align: "center",
        sx: {
            mt: 4,
            maxWidth: 311
        }
    }, "It looks like this link doesn’t have any meaningful information for you. Perhaps try our main website instead?"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        component: "a",
        href: "https://aurora.tech",
        align: "center",
        sx: {
            mt: 6,
            color: 'info.main',
            textDecoration: 'none',
            '&:focus-visible': {
                outline: '2px solid',
                outlineColor: 'info.main',
                borderRadius: 1
            }
        }
    }, "aurora.tech"));
}

//# sourceMappingURL=NotFoundPage.js.map